/**
 * Shipping Protection — cart toggle (variant 43641524650019).
 * Prefixed ship-prot. Uses document-level delegation (drawer re-renders wipe nodes).
 * Does not patch window.fetch.
 *
 * In-flight lock lives in module scope (survives drawer re-renders that replace the
 * button). Clicks during flight store a last-wins intention applied when free.
 */
(function () {
  if (window.__shipProtLoaded) return;
  window.__shipProtLoaded = true;

  var STORAGE_KEY = 'ls_ship_prot_optout';
  var VARIANT_FALLBACK = 43641524650019;
  /** Module-scoped in-flight lock — not the button's disabled/aria-busy (those are visual only). */
  var emVoo = false;
  /** Last desired action while busy: 'add' | 'remove' | null. Last click wins; no queue. */
  var intencao = null;
  /** Optimistic on/off while a request is in flight (re-applied after DOM swap). */
  var desejoVisual = null;
  var syncTimer = null;
  var lastSyncAt = 0;
  /** Ignore MutationObserver ticks caused by our own section swaps. */
  var skipObserver = false;
  /** Known protection-line presence in this page session: null | true | false. */
  var protKnown = null;
  /** Set on checkout click so we stop fighting Zipify's cart.js polling. */
  var checkoutGoing = false;
  /** True while we dispatch cart events so we do not re-enter reconcile. */
  var selfEvent = false;

  function hushObserver() {
    skipObserver = true;
    setTimeout(function () {
      if (!checkoutGoing) skipObserver = false;
    }, 700);
  }

  function cartFromPayload(payload) {
    if (!payload) return null;
    if (payload.items && Array.isArray(payload.items)) return payload;
    if (payload.cart && payload.cart.items) return payload.cart;
    if (payload.cartData && payload.cartData.items) return payload.cartData;
    return null;
  }

  function rootPath() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function routes() {
    var r = window.routes || {};
    var root = rootPath();
    return {
      add: r.cart_add_url || root + 'cart/add.js',
      change: r.cart_change_url || root + 'cart/change.js',
      update: r.cart_update_url || root + 'cart/update.js',
      cart: r.cart_url || root + 'cart.js',
      cartJs: root + 'cart.js',
    };
  }

  function getRoot() {
    return document.querySelector('[data-ship-prot-root]');
  }

  function getAllRoots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ship-prot-root]'));
  }

  function getSwitches() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ship-prot-switch]'));
  }

  function readConfig(el) {
    el = el || getRoot();
    if (!el) return null;
    return {
      variantId: parseInt(el.getAttribute('data-ship-prot-variant-id'), 10) || VARIANT_FALLBACK,
      country: (el.getAttribute('data-ship-prot-country') || '').toUpperCase(),
      optInMarket: el.getAttribute('data-ship-prot-opt-in-market') === 'true',
      priceLabel: el.getAttribute('data-ship-prot-price') || '$3.99',
      inCart: el.getAttribute('data-ship-prot-in-cart') === 'true',
      lineKey: el.getAttribute('data-ship-prot-line-key') || '',
      qty: parseInt(el.getAttribute('data-ship-prot-qty'), 10) || 0,
      otherCount: parseInt(el.getAttribute('data-ship-prot-other-count'), 10) || 0,
    };
  }

  function hasOptOut() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setOptOut(value) {
    try {
      if (value) {
        window.localStorage.setItem(STORAGE_KEY, '1');
      } else {
        window.localStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {
      /* ignore */
    }
  }

  /** Visual busy only — real lock is `emVoo` in the closure. */
  function setSwitchesBusy(isBusy) {
    getSwitches().forEach(function (btn) {
      if (isBusy) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-busy');
      }
    });
  }

  function priceFromConfig(cfg) {
    return (cfg && cfg.priceLabel) || (readConfig() && readConfig().priceLabel) || '$3.99';
  }

  /** Re-apply optimistic UI after the theme replaces the drawer markup. */
  function reaplicarEstadoAposRender() {
    var cfg = readConfig();
    var price = priceFromConfig(cfg);

    if (intencao) {
      setSwitchesState(intencao === 'add', price);
      if (emVoo) setSwitchesBusy(true);
      else processIntention();
      return true;
    }

    if (emVoo && desejoVisual !== null) {
      setSwitchesState(!!desejoVisual, price);
      setSwitchesBusy(true);
      return true;
    }

    return false;
  }

  function setSwitchesState(on, priceLabel) {
    var price = priceLabel || (readConfig() && readConfig().priceLabel) || '$3.99';
    getSwitches().forEach(function (btn) {
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      if (on) {
        btn.setAttribute('data-ship-prot-on', '');
        btn.setAttribute('aria-label', 'Remove shipping protection (' + price + ')');
      } else {
        btn.removeAttribute('data-ship-prot-on');
        btn.setAttribute('aria-label', 'Add shipping protection for ' + price);
      }
    });
    getAllRoots().forEach(function (root) {
      root.setAttribute('data-ship-prot-in-cart', on ? 'true' : 'false');
    });
  }

  function collectSectionIds() {
    var ids = [];
    var seen = {};

    function add(id) {
      if (!id || seen[id]) return;
      seen[id] = true;
      ids.push(id);
    }

    // Static cart drawer section
    add('cart-drawer');
    add('cart-icon-bubble');

    // Header / icon bubble wrappers
    var headerSection = document.querySelector('#shopify-section-header, .shopify-section-header');
    if (headerSection && headerSection.id) {
      add(headerSection.id.replace(/^shopify-section-/, ''));
    }

    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      var drawerSection = cartDrawerEl.closest('.shopify-section');
      if (drawerSection && drawerSection.id) {
        add(drawerSection.id.replace(/^shopify-section-/, ''));
      }
    }

    // Cart page sections
    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset && footer.dataset.id) add(footer.dataset.id);

    var items = document.getElementById('main-cart-items');
    if (items && items.dataset && items.dataset.id) add(items.dataset.id);

    document.querySelectorAll('.shopify-section[id*="cart"]').forEach(function (sec) {
      if (sec.id) add(sec.id.replace(/^shopify-section-/, ''));
    });

    return ids;
  }

  function sectionsParam() {
    // Cart AJAX API expects an array of section ids (Dawn/Shrine).
    return collectSectionIds();
  }

  function sectionsQuery() {
    return collectSectionIds().join(',');
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function replaceInner(target, sourceDoc, selector) {
    if (!target) return;
    var next = sourceDoc.querySelector(selector);
    if (!next) return;
    target.innerHTML = next.innerHTML;
  }

  function replaceElement(target, sourceDoc, selector) {
    if (!target) return;
    var next = sourceDoc.querySelector(selector);
    if (!next) return;
    target.innerHTML = next.innerHTML;
    // copy relevant attributes for empty state classes etc.
    if (next.className) target.className = next.className;
  }

  function applySectionHTML(id, html) {
    if (!html) return;
    var doc = parseHTML(html);

    // Cart drawer: replace the whole cart-drawer node contents / element
    if (id === 'cart-drawer' || id.indexOf('cart-drawer') !== -1) {
      var liveDrawer = document.querySelector('cart-drawer');
      var nextDrawer = doc.querySelector('cart-drawer');
      if (liveDrawer && nextDrawer) {
        // Section Rendering returns the closed drawer markup (no `active`).
        // Preserve open/runtime state classes so a content refresh does not slam it shut.
        var preserved = [];
        var liveClassList = liveDrawer.className ? liveDrawer.className.split(/\s+/) : [];
        for (var ci = 0; ci < liveClassList.length; ci++) {
          var c = liveClassList[ci];
          if (!c) continue;
          if (
            c === 'active' ||
            c === 'animate' ||
            c.indexOf('is-') === 0 ||
            c.indexOf('js-') === 0
          ) {
            preserved.push(c);
          }
        }
        var hadOpenAttr = liveDrawer.hasAttribute('open');

        liveDrawer.innerHTML = nextDrawer.innerHTML;
        liveDrawer.className = nextDrawer.className;

        // Empty cart: let the theme close as usual (do not force open).
        // `is-empty` from the new HTML / dispatchThemeEvents is authoritative.
        var cartEmpty =
          (nextDrawer.className &&
            (' ' + nextDrawer.className + ' ').indexOf(' is-empty ') !== -1) ||
          nextDrawer.classList.contains('is-empty');

        if (!cartEmpty) {
          for (var pi = 0; pi < preserved.length; pi++) {
            var pc = preserved[pi];
            if (pc === 'is-empty') continue;
            if (!liveDrawer.classList.contains(pc)) liveDrawer.classList.add(pc);
          }
          if (hadOpenAttr && !liveDrawer.hasAttribute('open')) {
            liveDrawer.setAttribute('open', '');
          }
        }
        return;
      }
      var liveSection = document.getElementById('shopify-section-' + id);
      var nextSection = doc.getElementById('shopify-section-' + id) || doc.querySelector('.shopify-section');
      if (liveSection && nextSection) {
        liveSection.innerHTML = nextSection.innerHTML;
        return;
      }
    }

    // Cart icon bubble
    if (id === 'cart-icon-bubble' || id.indexOf('cart-icon-bubble') !== -1) {
      var liveBubble = document.getElementById('shopify-section-cart-icon-bubble') ||
        document.getElementById('cart-icon-bubble') ||
        document.querySelector('#cart-icon-bubble');
      var nextBubble =
        doc.getElementById('shopify-section-cart-icon-bubble') ||
        doc.getElementById('cart-icon-bubble') ||
        doc.querySelector('#cart-icon-bubble') ||
        doc.querySelector('.shopify-section');
      if (liveBubble && nextBubble) {
        if (liveBubble.id === 'cart-icon-bubble' || liveBubble.matches('#cart-icon-bubble')) {
          liveBubble.innerHTML = nextBubble.innerHTML;
        } else {
          liveBubble.innerHTML = nextBubble.innerHTML;
        }
        return;
      }
      // Bubble may live inside header
      var headerBubble = document.querySelector('#cart-icon-bubble');
      var srcBubble = doc.querySelector('#cart-icon-bubble');
      if (headerBubble && srcBubble) {
        headerBubble.innerHTML = srcBubble.innerHTML;
      }
      return;
    }

    // Generic shopify-section swap
    var live = document.getElementById('shopify-section-' + id);
    var next = doc.getElementById('shopify-section-' + id) || doc.querySelector('.shopify-section');
    if (live && next) {
      live.innerHTML = next.innerHTML;
      return;
    }

    // main-cart-footer by element id
    if (id === 'cart-footer' || id.indexOf('cart-footer') !== -1 || id.indexOf('main-cart-footer') !== -1) {
      replaceElement(document.getElementById('main-cart-footer'), doc, '#main-cart-footer');
    }
    if (id === 'cart-items' || id.indexOf('cart-items') !== -1 || id.indexOf('main-cart-items') !== -1) {
      replaceElement(document.getElementById('main-cart-items'), doc, '#main-cart-items');
      // Some themes wrap items differently
      var jsContents = document.querySelector('#main-cart-items .js-contents, cart-items .js-contents');
      var nextJs = doc.querySelector('#main-cart-items .js-contents, cart-items .js-contents, .js-contents');
      if (jsContents && nextJs) jsContents.innerHTML = nextJs.innerHTML;
    }
  }

  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      applySectionHTML(id, sections[id]);
    });
  }

  function dispatchThemeEvents(cart) {
    selfEvent = true;
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart || {} }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart || {} }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: cart || {} }));
    } catch (e) {
      /* ignore */
    }
    selfEvent = false;

    // Dawn / Shrine pub-sub
    try {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ship-prot', cart: cart });
      }
    } catch (e) {
      /* ignore */
    }

    // cart-drawer custom element hooks used by some themes
    try {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        if (typeof drawer.onCartUpdate === 'function') drawer.onCartUpdate();
        if (cart && cart.item_count === 0) {
          drawer.classList.add('is-empty');
        } else if (cart) {
          drawer.classList.remove('is-empty');
        }
      }
    } catch (e) {
      /* ignore */
    }
  }

  function fetchSectionsOnly() {
    var ids = sectionsQuery();
    if (!ids || !ids.length) return Promise.resolve(null);
    // /cart is cheap; requesting sections on the current product URL re-renders the PDP.
    var url = rootPath() + 'cart?sections=' + encodeURIComponent(ids);
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('sections ' + res.status);
        return res.json();
      })
      .catch(function () {
        return null;
      });
  }

  function refreshUI(sectionsFromResponse, cart) {
    hushObserver();
    if (sectionsFromResponse && Object.keys(sectionsFromResponse).length) {
      applySections(sectionsFromResponse);
      dispatchThemeEvents(cart);
      return Promise.resolve(cart);
    }
    return fetchSectionsOnly().then(function (sections) {
      hushObserver();
      if (sections) applySections(sections);
      dispatchThemeEvents(cart);
      return cart;
    });
  }

  function fetchCart() {
    return fetch(routes().cartJs, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      if (!res.ok) throw new Error('cart ' + res.status);
      return res.json();
    });
  }

  function findProtectionLine(cart, variantId) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id === variantId || String(items[i].id) === String(variantId)) {
        return items[i];
      }
    }
    return null;
  }

  function otherItemCount(cart, variantId) {
    var items = (cart && cart.items) || [];
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id !== variantId && String(items[i].id) !== String(variantId)) {
        n += items[i].quantity;
      }
    }
    return n;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && data.description) || 'cart request failed');
          err.payload = data;
          throw err;
        }
        return data;
      });
    });
  }

  /**
   * Add protection without duplicating: if the line already exists, only clamp qty to 1.
   */
  function addProtection(variantId, knownCart) {
    hushObserver();
    var start = knownCart ? Promise.resolve(knownCart) : fetchCart();
    return start.then(function (cart) {
      var line = findProtectionLine(cart, variantId);
      if (line) {
        if (line.quantity !== 1) {
          return changeLine(line.key || line.id, 1);
        }
        return cart;
      }
      var sectionIds = sectionsParam();
      return postJSON(routes().add, {
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionIds,
        sections_url: '/cart',
      }).then(function (data) {
        protKnown = true;
        var added = (data && data.items && data.items[0]) || data;
        var qty = added && added.quantity;
        var key = added && (added.key || added.id);
        if (qty && qty > 1 && key) {
          return changeLine(key, 1);
        }
        return refreshUI(data.sections, data).then(function () {
          return data;
        });
      });
    });
  }

  function changeLine(lineKeyOrId, quantity) {
    hushObserver();
    var sectionIds = sectionsParam();
    var body = {
      quantity: quantity,
      sections: sectionIds,
      sections_url: '/cart',
    };
    // Prefer line item key when available
    if (lineKeyOrId && String(lineKeyOrId).indexOf(':') !== -1) {
      body.id = lineKeyOrId;
    } else {
      body.id = lineKeyOrId;
    }
    return postJSON(routes().change, body).then(function (data) {
      return refreshUI(data.sections, data).then(function () {
        return data;
      });
    });
  }

  function removeProtection(cart, variantId) {
    var line = findProtectionLine(cart, variantId);
    if (!line) return Promise.resolve(cart);
    return changeLine(line.key || line.id, 0);
  }

  function ensureQtyOne(cart, variantId) {
    var line = findProtectionLine(cart, variantId);
    if (!line) return Promise.resolve(cart);
    if (line.quantity <= 1) return Promise.resolve(cart);
    return changeLine(line.key || line.id, 1);
  }

  /**
   * Apply a single desired cart state ('add' | 'remove') against server truth.
   * Never duplicates the protection line.
   */
  function applyDesired(desired) {
    var cfg = readConfig();
    var variantId = (cfg && cfg.variantId) || VARIANT_FALLBACK;
    var price = priceFromConfig(cfg);

    if (desired === 'add') {
      if (protKnown === true && !(cfg && cfg.qty > 1)) {
        setSwitchesState(true, price);
        desejoVisual = true;
        return Promise.resolve(null);
      }
      if (cfg && cfg.otherCount === 0 && !cfg.inCart) {
        setSwitchesState(false, price);
        desejoVisual = false;
        protKnown = false;
        return Promise.resolve(null);
      }
      if (cfg && cfg.inCart && cfg.qty === 1 && cfg.lineKey) {
        setSwitchesState(true, price);
        desejoVisual = true;
        protKnown = true;
        return Promise.resolve(null);
      }
      if (cfg && cfg.lineKey && cfg.qty !== 1) {
        return changeLine(cfg.lineKey, 1).then(function (updated) {
          setSwitchesState(true, price);
          desejoVisual = true;
          protKnown = true;
          return updated;
        });
      }
      protKnown = true;
      return addProtection(variantId, { items: [] }).then(function (updated) {
        setSwitchesState(true, price);
        desejoVisual = true;
        return updated;
      });
    }

    setOptOut(true);
    if (cfg && cfg.lineKey) {
      protKnown = false;
      return changeLine(cfg.lineKey, 0).then(function (updated) {
        setSwitchesState(false, price);
        desejoVisual = false;
        return updated;
      });
    }
    if (cfg && !cfg.inCart && protKnown !== true) {
      protKnown = false;
      setSwitchesState(false, price);
      desejoVisual = false;
      return Promise.resolve(null);
    }

    return fetchCart().then(function (cart) {
      var line = findProtectionLine(cart, variantId);
      if (!line) {
        setSwitchesState(false, price);
        desejoVisual = false;
        return cart;
      }
      return removeProtection(cart, variantId).then(function (updated) {
        setSwitchesState(false, price);
        desejoVisual = false;
        return updated;
      });
    });
  }

  /**
   * Run the latest stored intention when no request is in flight.
   * After each request, drains a newer intention if one arrived mid-flight.
   */
  function processIntention() {
    if (emVoo) return;
    if (!intencao) return;

    var desired = intencao;
    intencao = null;
    emVoo = true;
    desejoVisual = desired === 'add';
    setSwitchesState(desejoVisual, priceFromConfig(readConfig()));

    applyDesired(desired)
      .catch(function (err) {
        if (window.console && console.warn) {
          console.warn('[ship-prot] toggle', err);
        }
        // Reconcile visual with cart truth; do not leave the control stuck.
        return fetchCart()
          .then(function (cart) {
            var cfg = readConfig();
            var variantId = (cfg && cfg.variantId) || VARIANT_FALLBACK;
            var on = !!findProtectionLine(cart, variantId);
            protKnown = on;
            desejoVisual = on;
            setSwitchesState(on, priceFromConfig(cfg));
            return null;
          })
          .catch(function () {
            return null;
          });
      })
      .then(function () {
        emVoo = false;
        lastSyncAt = Date.now();

        if (intencao) {
          setSwitchesState(intencao === 'add', priceFromConfig(readConfig()));
          processIntention();
        } else {
          desejoVisual = null;
        }
      });
  }

  /**
   * Core reconciliation — auto-add, opt-out, orphan protection, qty clamp.
   */
  function reconcile(options) {
    options = options || {};
    // Do not fight an in-flight toggle, a pending intention, or Zipify checkout.
    if (checkoutGoing && !options.force) return Promise.resolve(null);
    if ((emVoo || intencao) && !options.force) return Promise.resolve(null);

    var cfg = readConfig();
    var variantId = (cfg && cfg.variantId) || VARIANT_FALLBACK;
    var optOut = hasOptOut();
    var optInMarket = cfg ? cfg.optInMarket : false;
    var price = cfg && cfg.priceLabel;

    function finish(result) {
      emVoo = false;
      lastSyncAt = Date.now();
      if (result && result.items) {
        protKnown = !!findProtectionLine(result, variantId);
      }
      if (intencao) processIntention();
      return result;
    }

    function runWithCart(cart) {
      var line = findProtectionLine(cart, variantId);
      var others = otherItemCount(cart, variantId);

      if (line && others === 0) {
        protKnown = false;
        return removeProtection(cart, variantId).then(function (updated) {
          setSwitchesState(false, price);
          return updated;
        });
      }

      if (others === 0) {
        protKnown = false;
        setSwitchesState(false, price);
        return cart;
      }

      if (line && line.quantity > 1) {
        protKnown = true;
        return ensureQtyOne(cart, variantId).then(function (updated) {
          setSwitchesState(true, price);
          return updated;
        });
      }

      if (line) {
        protKnown = true;
        setSwitchesState(true, price);
        return cart;
      }

      setSwitchesState(false, price);

      if (options.skipAutoAdd) return cart;

      if (!optOut && !optInMarket) {
        protKnown = true;
        setSwitchesState(true, price);
        return addProtection(variantId, cart).then(function (updated) {
          setSwitchesState(true, price);
          return updated;
        });
      }

      return cart;
    }

    // Drawer HTML is source of truth when we are not mid-request.
    if (!emVoo && cfg && cfg.otherCount > 0 && !cfg.inCart) {
      protKnown = false;
    }

    // Fast path: drawer markup already says protection is in, qty 1.
    if (cfg && cfg.inCart && cfg.qty <= 1 && cfg.otherCount > 0 && protKnown !== false) {
      protKnown = true;
      setSwitchesState(true, price);
      lastSyncAt = Date.now();
      return Promise.resolve(null);
    }

    // Fast auto-add from drawer markup — skip the extra cart.js round-trip.
    if (
      !options.skipAutoAdd &&
      cfg &&
      cfg.otherCount > 0 &&
      !cfg.inCart &&
      !optOut &&
      !optInMarket &&
      protKnown !== true
    ) {
      emVoo = true;
      protKnown = true;
      setSwitchesState(true, price);
      return addProtection(variantId, { items: [] })
        .then(function (updated) {
          setSwitchesState(true, price);
          return updated;
        })
        .catch(function (err) {
          protKnown = null;
          if (window.console && console.warn) console.warn('[ship-prot]', err);
          return fetchCart().then(runWithCart);
        })
        .then(finish);
    }

    var known = cartFromPayload(options.cart);
    emVoo = true;
    var start = known ? Promise.resolve(known) : fetchCart();
    return start
      .then(runWithCart)
      .catch(function (err) {
        if (window.console && console.warn) {
          console.warn('[ship-prot]', err);
        }
        return null;
      })
      .then(finish);
  }

  function scheduleReconcile(opts) {
    if (checkoutGoing && !(opts && opts.force)) return;
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncTimer = null;
      if (checkoutGoing && !(opts && opts.force)) return;
      if (skipObserver && !(opts && opts.force)) return;
      if (emVoo && !(opts && opts.force)) return;
      // Pending user intent takes priority over background sync after re-render.
      if (reaplicarEstadoAposRender()) return;
      // Debounce Zipify / theme cart.js spam. Observer ticks are cheaper to skip.
      var quiet = opts && opts.immediate ? 400 : 1200;
      if (Date.now() - lastSyncAt < quiet && !(opts && opts.force)) return;
      reconcile(opts);
    }, opts && opts.immediate ? 0 : 80);
  }

  function onToggleClick(event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-ship-prot-switch]') : null;
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    var cfg = readConfig(btn.closest('[data-ship-prot-root]')) || readConfig();
    var price = priceFromConfig(cfg);

    // Base the toggle on optimistic / pending state when the DOM node was just replaced.
    var currentlyOn;
    if (emVoo && desejoVisual !== null) {
      currentlyOn = !!desejoVisual;
    } else if (intencao) {
      currentlyOn = intencao === 'add';
    } else {
      currentlyOn = btn.getAttribute('aria-checked') === 'true';
    }
    var wantOn = !currentlyOn;

    // Immediate visual feedback (before network).
    desejoVisual = wantOn;
    setSwitchesState(wantOn, price);

    // Last-wins intention — never drop the click while a request is in flight.
    intencao = wantOn ? 'add' : 'remove';

    if (emVoo) return;

    processIntention();
  }

  // 1. Document-level delegation — survives full drawer re-renders
  document.addEventListener('click', onToggleClick, true);

  function markCheckoutGoing(event) {
    var t = event.target && event.target.closest ? event.target.closest('[name="checkout"], #CartDrawer-Checkout, [href="/checkout"], [href*="/checkouts/"]') : null;
    if (!t) return;
    checkoutGoing = true;
    skipObserver = true;
  }
  document.addEventListener('click', markCheckoutGoing, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form) return;
    if (form.querySelector('[name="checkout"]') || (form.getAttribute && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart') !== -1 && form.querySelector('[name="checkout"]'))) {
      checkoutGoing = true;
      skipObserver = true;
    }
  }, true);

  // Keyboard: role=switch is a button, so Enter/Space work natively; keep click path only.

  // External cart mutations (apps / theme)
  document.addEventListener('cart:updated', function (e) {
    if (selfEvent || checkoutGoing) return;
    if (e && e.detail && e.detail.source === 'ship-prot') return;
    var incoming = cartFromPayload(e && e.detail);
    if (incoming && !emVoo) {
      var cfgNow = readConfig();
      var vid = (cfgNow && cfgNow.variantId) || VARIANT_FALLBACK;
      protKnown = !!findProtectionLine(incoming, vid);
    }
    scheduleReconcile({ skipAutoAdd: false, cart: incoming, immediate: true });
  });
  document.addEventListener('cart:refresh', function (e) {
    if (selfEvent || checkoutGoing) return;
    scheduleReconcile({ skipAutoAdd: false, cart: cartFromPayload(e && e.detail) });
  });

  try {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (payload) {
        if (selfEvent || checkoutGoing) return;
        if (payload && payload.source === 'ship-prot') return;
        scheduleReconcile({ skipAutoAdd: false, cart: cartFromPayload(payload), immediate: true });
      });
    }
  } catch (e) {
    /* ignore */
  }

  // When the drawer re-renders our root, re-run reconcile (covers add-to-cart from PDP)
  var moTimer = null;
  var observer = new MutationObserver(function () {
    if (checkoutGoing || skipObserver || emVoo) return;
    if (moTimer) clearTimeout(moTimer);
    moTimer = setTimeout(function () {
      if (checkoutGoing || skipObserver || emVoo) return;
      if (!getRoot()) return;
      scheduleReconcile({ skipAutoAdd: false });
    }, 80);
  });

  function startObserver() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      observer.observe(drawer, { childList: true, subtree: true });
      return;
    }
    if (!document.body) return;
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    startObserver();
    // Initial auto-add / cleanup
    scheduleReconcile({ skipAutoAdd: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
